import { SERVICE_URL } from './ServiceURL'

class ProductsService {
  constructor (resource) {
    this.store = resource.$store
    this.http = resource.$http
  }

  getAll () {
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/products/`, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
        .then(response => response.json())
        .then(plans => resolve(plans))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }

  getAllAdditionals () {
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/products/adicionais`, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
        .then(response => response.json())
        .then(additionals => resolve(additionals))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }
}


export default ProductsService



// WEBPACK FOOTER //
// ./src/service/ProductsService.js